export class SearchModel {
  analystId:string = '';
  name: string = '';
  email: string = '';
  title: string = '';
  office: string = '';
  department: string = '';
}
